import ProductSpecifications, {
  Table,
} from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theming/Theming';

const Wrapper = styled('div')`
  ${Table} {
    ul {
      list-style-type: none;
      margin-left: 0;
      display: flex;
      flex-wrap: wrap;
      li:not(:last-child) {
        margin-right: 5px;
        &:after {
          content: ',';
          margin: 0 2px;
        }
      }
    }
    tr th {
      ${theme.above.lg} {
        width: 240px;
      }
    }
    tr:nth-of-type(2n-1) {
      //background: ${theme.colors.greys[1]};
    }
    tbody > tr {
      background: none;
      border-bottom: none;
      height: 1rem;
      ${theme.above.md} {
        &:nth-of-type(2n + 1) {
        }
      }
    }
  }
`;

export const ProductSpecificationsWrapper = ({ className, fields }) => {
  return (
    <Wrapper>
      <ProductSpecifications className={className} fields={fields} />
    </Wrapper>
  );
};
